import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer } from '../../../../styled/layout.styled';
import { Caption } from '../../../../styled/typograpghy.styled';
import arrowDownIcon from '../assets/Arrow Down.svg';

const StyledFlexContainer = styled(FlexContainer)`
  width: 100%;
  border-radius: 4px;
  background-color: #f8f5ff;
  height: 100%;
`;

const StyledTitle = styled.p`
  width: 73%;
  color: #12033d;
`;

const StyledCaption = styled(Caption)`
  color: #6e658a;
  opacity: ${({ collapsed }) => (collapsed ? '1' : '0')};
  transition: opacity 0.25s ease;
`;

const StyledCircle = styled(FlexContainer)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: solid 1px #c7baf1;
  background-color: #f8f5ff;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  >img{
  ${({ trigger }) => trigger
    ? css`
          transform: rotateZ(-180deg);
        `
    : css`
          transform: rotateZ(-360deg);
        `};
    transition: all .25s ease;
  };
  }
`;
const StyledCaptionContainer = styled(FlexContainer)`
  display: block;
  overflow-y: hidden;
  max-height: ${({ collapsed }) => (collapsed ? '500px' : '0')};
  padding: ${({ collapsed }) => (collapsed ? '12px 24px 24px 24px' : '0')};
  transition: all 0.25s ease;
`;

const AqCard = ({ title, children }) => {
  const [toggle, setToggle] = useState(false);
  return (
    <StyledFlexContainer flexDirection="column" justifyContent="center" margin="0 0 4px 0">
      <FlexContainer
        onClick={() => setToggle(prevState => !prevState)}
        justifyContent="space-between"
        padding="22px 24px"
        alignItems="center"
        cursor="pointer"
      >
        <StyledTitle className="bold">{title}</StyledTitle>
        <StyledCircle trigger={toggle}>
          <img src={arrowDownIcon} alt="icon" />
        </StyledCircle>
      </FlexContainer>
      <StyledCaptionContainer collapsed={toggle ? 1 : 0}>
        <StyledCaption collapsed={toggle}>{children}</StyledCaption>
      </StyledCaptionContainer>
    </StyledFlexContainer>
  );
};

AqCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

export default AqCard;
